(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger instanceof HTMLElement) {
      trigger.click();
    }
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    return response.json();
  }

  function cartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map((item) => item instanceof HTMLElement ? item.dataset.sectionId : '')
      .filter(Boolean);
  }

  function dispatchCartUpdate(cart, sourceId, data) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || undefined,
        sourceId,
        data: data || {}
      }
    }));
  }

  function setupQuickForms() {
    document.querySelectorAll('form[data-yn-product-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const originalText = button ? button.textContent : '';
        const formData = new FormData(form);
        const sections = cartSectionIds();

        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        if (button) {
          button.disabled = true;
          button.textContent = 'Adding...';
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' }
          });
          const payload = await response.json();

          if (!response.ok || payload.status) {
            throw new Error(payload.description || payload.message || 'Unable to add this ritual.');
          }

          const cart = await fetchCart();
          dispatchCartUpdate(cart, form.id || 'yesnap-quick-add', {
            source: 'yesnap-redesign',
            itemCount: 1,
            variantId: String(formData.get('id') || ''),
            sections: payload.sections
          });

          if (button) button.textContent = 'Added';
          openCartDrawer();
        } catch (error) {
          if (button) button.textContent = error.message || 'Try again';
        } finally {
          window.setTimeout(() => {
            if (button) {
              button.disabled = false;
              button.textContent = originalText || 'Add to cart';
            }
          }, 1200);
        }
      });
    });
  }

  function setupGoalChips() {
    document.querySelectorAll('[data-yn-goal-target]').forEach((chip) => {
      chip.addEventListener('click', (event) => {
        const target = document.getElementById(chip.getAttribute('data-yn-goal-target'));
        if (!target) return;
        event.preventDefault();

        document.querySelectorAll('[data-yn-goal-target]').forEach((item) => {
          item.classList.toggle('is-active', item === chip);
        });

        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
        }

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        target.focus({ preventScroll: true });
        target.classList.remove('is-goal-highlight');
        void target.offsetWidth;
        target.classList.add('is-goal-highlight');

        window.setTimeout(() => {
          target.classList.remove('is-goal-highlight');
        }, reduceMotion ? 0 : 1100);
      });
    });
  }

  function setupFinderCardDetails() {
    const hoverQuery = window.matchMedia('(hover: hover) and (min-width: 761px)');

    document.querySelectorAll('.yn-finder .yn-product-card--compact .yn-product-card__details').forEach((details) => {
      const card = details.closest('.yn-product-card--compact');
      if (!(card instanceof HTMLElement) || !(details instanceof HTMLDetailsElement)) return;

      card.addEventListener('mouseenter', () => {
        if (!hoverQuery.matches) return;
        details.open = true;
      });

      card.addEventListener('mouseleave', () => {
        if (!hoverQuery.matches) return;
        details.open = false;
      });
    });

    document.querySelectorAll('.yesnap-theme-shell[data-yesnap-build="visual-polish-2026-05-29-v2"] .yn-finder .yn-product-card--compact').forEach((card) => {
      if (!(card instanceof HTMLElement) || card.querySelector('.yn-product-card__details') || card.querySelector('.yn-product-card__mobile-toggle')) return;

      const body = card.querySelector('.yn-product-card__body');
      if (!(body instanceof HTMLElement)) return;

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'yn-product-card__mobile-toggle';
      toggle.textContent = 'Use and benefits';
      toggle.setAttribute('aria-expanded', 'false');
      body.appendChild(toggle);

      toggle.addEventListener('click', () => {
        const isExpanded = card.classList.toggle('is-yn-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    });
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function packCopyForVariant(variant, fallbackIndex) {
    const title = String(variant?.title || variant?.public_title || '').toLowerCase();
    const sku = String(variant?.sku || '').toLowerCase();

    if (sku.includes('*3') || title.includes('90') || fallbackIndex === 2) {
      return {
        label: '90 servings',
        hint: 'Unlocks free U.S. shipping · best consistency'
      };
    }

    if (sku.includes('*2') || title.includes('60') || fallbackIndex === 1) {
      return {
        label: '60 servings',
        hint: 'Two-month routine · closer to free shipping'
      };
    }

    return {
      label: '30 servings',
      hint: 'Trial ritual'
    };
  }

  function normalizePackLabels(root) {
    const scope = root || document;
    const variantsEl = scope.querySelector('[data-yesnap-variants]');
    let variants = [];

    try {
      variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    } catch (error) {
      variants = [];
    }

    scope.querySelectorAll('[data-yn-pack-options]').forEach((group) => {
      group.querySelectorAll('[data-yn-pack-option]').forEach((button, index) => {
        const variantId = button.getAttribute('data-variant-id');
        const variant = variants.find((item) => String(item.id) === String(variantId));
        const copy = packCopyForVariant(variant, index);
        const priceText = variant?.price
          ? formatMoney(variant.price)
          : (button.textContent.match(/\$[\d,.]+(?:\.\d{2})?/) || [''])[0];

        button.dataset.packLabel = copy.label;
        button.dataset.packHint = copy.hint;

        const title = button.querySelector('strong');
        const detail = button.querySelector('span');
        if (title) title.textContent = copy.label;
        if (detail) detail.textContent = priceText ? `${copy.hint} · ${priceText}` : copy.hint;
      });
    });
  }

  function setupPackButtons() {
    normalizePackLabels();

    document.querySelectorAll('[data-yn-pack-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const variantId = button.getAttribute('data-variant-id');
        const root = button.closest('.pdp-conversion');
        const select = root ? root.querySelector('[data-yesnap-variant-select]') : document.querySelector('[data-yesnap-variant-select]');

        if (select && variantId) {
          select.value = variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const group = button.closest('[data-yn-pack-options]');
        if (group) {
          group.querySelectorAll('[data-yn-pack-option]').forEach((item) => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
        }
      });
    });

    document.querySelectorAll('[data-yesnap-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const root = select.closest('.pdp-conversion');
        const group = root ? root.querySelector('[data-yn-pack-options]') : null;
        if (!group) return;

        normalizePackLabels(root);
        group.querySelectorAll('[data-yn-pack-option]').forEach((item) => {
          const isActive = item.getAttribute('data-variant-id') === select.value;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });

      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function setupPackJumpLinks() {
    document.querySelectorAll('[data-yesnap-pack-jump]').forEach((link) => {
      link.addEventListener('click', () => {
        const packText = String(link.getAttribute('data-yesnap-pack-jump') || link.textContent || '').toLowerCase();
        const packNumber = (packText.match(/30|60|90/) || [])[0];
        if (!packNumber) return;

        window.setTimeout(() => {
          const option = Array.from(document.querySelectorAll('[data-yn-pack-option]')).find((button) => {
            const label = String(button.getAttribute('data-pack-label') || button.textContent || '').toLowerCase();
            return label.includes(packNumber);
          });
          if (option instanceof HTMLButtonElement) option.click();
        }, 0);
      });
    });
  }

  function setupResultsRail() {
    document.querySelectorAll('.yn-ugc-card').forEach((card) => {
      const video = card.querySelector('video');
      const playButton = card.querySelector('.yn-ugc-card__play');
      if (!(video instanceof HTMLVideoElement) || !(playButton instanceof HTMLButtonElement)) return;

      const setPlaying = (isPlaying) => {
        card.classList.toggle('is-playing', isPlaying);
        playButton.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} ${playButton.getAttribute('aria-label')?.replace(/^Play |^Pause /, '') || 'routine clip'}`);
      };

      playButton.addEventListener('click', async () => {
        try {
          if (video.paused) {
            document.querySelectorAll('.yn-ugc-card video').forEach((otherVideo) => {
              if (otherVideo !== video && otherVideo instanceof HTMLVideoElement) {
                otherVideo.pause();
              }
            });
            await video.play();
          } else {
            video.pause();
          }
        } catch (error) {
          setPlaying(false);
        }
      });

      video.addEventListener('click', () => {
        if (video.paused) {
          playButton.click();
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', () => setPlaying(true));
      video.addEventListener('pause', () => setPlaying(false));
      video.addEventListener('ended', () => setPlaying(false));
    });
  }

  ready(() => {
    setupQuickForms();
    setupGoalChips();
    setupFinderCardDetails();
    setupPackButtons();
    setupPackJumpLinks();
    setupResultsRail();
  });
})();
